
import React, { useState, useEffect, useContext } from 'react';
import { ImCross } from "react-icons/im";
import { RiDeleteBin6Fill } from "react-icons/ri";
import toast from 'react-hot-toast';
import LoadingSpinner from '../../Components/CommonComponent/loadingSpiner/LoadingSpinner';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';
import DateFilter from '../../Components/CommonComponent/Dropdown/DateFilter';
import { CommonContext } from '../../App';
import DeleteDataModal from '../../Components/CommonComponent/Modals/DeleteDataModal';


const TransactionEditModal = ({ isOpen, onClose, entry, onSuccess, startDate, endDate, setDefaultDateRange, onDateChange, }) => {
  const [ComponentToRender, setComponentToRender] = useState(null);
  const [fullEntryData, setFullEntryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const primeLanguage = localStorage.getItem("selectedLanguage");
  const {userData, branchId, dateRange, setDateRange } = useContext(CommonContext);
    const adminId = userData?.user?.id;
  const userRole = userData?.user?.role;
  const [modalDate, setModalDate] = useState({
  startDate,
  endDate,
});
 const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteEntry, setSelectedDeleteEntry] = useState(null);
useEffect(() => {
  if (isOpen) {
    setModalDate({ startDate, endDate });
  }
}, [isOpen, startDate, endDate]);
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  // Fetch full entry data when modal opens
  useEffect(() => {
    if (!isOpen || !entry) return;

    const fetchFullEntryData = async () => {
      setLoading(true);
      try {
        let endpoint = '';
        let keyField = '';

        switch (entry.voucher_type) {
          case 'payment':
            endpoint = 'payment/get-payment-by-key';
            keyField = 'payment_key';
            break;
          case 'receipt':
            endpoint = 'receipt/get-receipt-by-key';
            keyField = 'receipt_key';
            break;
          case 'purchase':
            endpoint = 'purchase/get-purchase-by-key';
            keyField = 'purchase_key';
            break;
          case 'transportation':
            if (entry.part === "sales") {
              endpoint = 'sales/get-sales-by-key';
              keyField = 'entry_key';
            } else {
              endpoint = 'purchase/get-purchase-by-key';
              keyField = 'purchase_key';
            }
            break;
          case 'loading/unloading':
            if (entry.part === "sales") {
              endpoint = 'sales/get-sales-by-key';
              keyField = 'entry_key';
            } else {
              endpoint = 'purchase/get-purchase-by-key';
              keyField = 'purchase_key';
            }
            break;
          case 'from journal':
          case 'to journal':
            endpoint = 'journal/get-journal-by-key';
            keyField = 'journal_key';
            break;
          default: // sales
            endpoint = 'sales/get-sales-by-key';
            keyField = 'entry_key';
        }
        // const url=`${endpoint}?${keyField}=${entry[keyField]}&branchId=${entry.branchId || entry.branch_id}`
        // console.log("url",url
        const res = await api.get(
          `${endpoint}?${keyField}=${entry[keyField]}&branchId=${entry.branchId || entry.branch_id}`
        );

        if (res.data.success) {
          setFullEntryData(res.data);

          // Load component after data is fetched
         await loadComponent(entry.voucher_type, entry.part);
        }
      } catch (error) {
        console.error('Error fetching entry data:', error);
        toast.error('Failed to load transaction details');
        onClose();
      } finally {
        setLoading(false);
      }
    };

    fetchFullEntryData();
  }, [isOpen, entry]);

  const loadComponent = async (voucherType, part) => {
    try {
      let componentModule;

      switch (voucherType) {
        case 'payment':
          componentModule = await import('../../../src/Pages/AllTablesPage/PaymentTable');
          break;
        case 'receipt':
          componentModule = await import('../../../src/Pages/AllTablesPage/ReceiptTable');
          break;
        case 'purchase':
          componentModule = await import('../../../src/Pages/AllTablesPage/PurchaseTable');
          break;
        case 'transportation':
          if (part === "sales") {
            componentModule = await import('../../../src/Pages/AllTablesPage/SalesTable');
          } else {
            componentModule = await import('../../../src/Pages/AllTablesPage/PurchaseTable');
          }
          break;
        case 'loading/unloading':
          if (part === "sales") {
            componentModule = await import('../../../src/Pages/AllTablesPage/SalesTable');
          } else {
            componentModule = await import('../../../src/Pages/AllTablesPage/PurchaseTable');
          }
          break;
        case 'from journal':
        case 'to journal':
          componentModule = await import('../../../src/Pages/AllTablesPage/JournalEntryTable');
          break;
        default:
          componentModule = await import('../../../src/Pages/AllTablesPage/SalesTable');
      }

      setComponentToRender(() => componentModule.default);
    } catch (error) {
      console.error('Error loading component:', error);
      toast.error('Failed to load editor');
    }
  };

  if (!isOpen) return null;
  const handleSaveSuccess = () => {
  // 🔥 Ab parent ko date bhejo
  onDateChange?.(modalDate);
  setDefaultDateRange(modalDate);
  onSuccess?.();
};

const handleDeleteApi = async (entry) => {
  try {
    const voucherType = entry.voucher_type;
    if (!voucherType) throw new Error("Voucher type missing");

    let url = "";
    let payload = {
      branchId,
      adminId,
      role: userRole,
      deleteReason: entry.deleteReason,
      deletePassword: entry.deletePassword,
      entry,
    };

    switch (voucherType) {
      case "sales":
        url = "sales/delete-sales-entry";
        payload.entryKey = entry.entry_key || entry.entryKey;
        break;

      case "purchase":
        url = "purchase/delete-purchase-entry";
        payload.purchaseKey = entry.purchase_key || entry.purchaseKey;
        break;

      case "receipt":
        url = "receipt/delete-receipt-entry";
        payload.receiptKey = entry.receipt_key || entry.receiptKey;
        break;

      case "payment":
        url = "payment/delete-payment-entry";
        payload.paymentKey = entry.payment_key || entry.paymentKey;
        break;

      case "from journal":
      case "to journal":
        url = "journal/delete-journal-entry";
        payload.journalKey =
          entry.journal_key || entry.entry_key || entry.entryKey;
        break;

      default:
        throw new Error("Invalid voucher type: " + voucherType);
    }

    const res = await api.post(url, payload);

    if (res.data.success) {
      toast.success("Entry deleted successfully");

      // ✅ Close delete modal
      setShowDeleteModal(false);
      setSelectedDeleteEntry(null);

      // ✅ Close edit modal
      onClose();

      // ✅ Refresh parent data
      onSuccess?.();
    }
  } catch (error) {
    console.error("Delete error:", error);
    toast.error(
      error.response?.data?.message || error.message || "Delete failed"
    );
  }
};


  return (
    <div className="fixed inset-0 z-[999] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black/50"
      // onClick={onClose}
      />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-7xl bg-white rounded-lg shadow-xl z-[1000]"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-2 py-2 border-b bg-theme-headerBg text-white rounded-t-lg">
            <h2 className="text-lg mt-2 font-semibold capitalize px-2">
              {/* ${entry?.voucher_type || 'Transaction'} */}
              {primeLanguage === "hi" ?
                ` ${t("entry")} ${t("edit")}` : `${t("edit")} ${t("entry")} `}
            </h2>

            <div className='flex gap-2'>
              <div className='bg-white w-[40px] me-2 rounded-1 flex justify-center items-center'>
                <div className="text-red-500 ">
                 <RiDeleteBin6Fill  className='text-xl cursor-pointer 'title='Delete Entries' onClick={() => {
                                    setSelectedDeleteEntry(entry);
                                    setShowDeleteModal(true);
                                  }} />
                </div>
              </div>
              <div className='bg-white p-[4px] rounded-1'>
                <div className="text-theme-headerBg">
                  <DateFilter
                    defaultDate={{ startDate: startDate, endDate: endDate }}
                    storageKey="balanceSheet"
                    customMode="single"
                    availableFilters={["today", "custom"]}
                    onChange={(r) => {

                      setModalDate({
                        startDate: r.startDate,
                        endDate: r.startDate,
                      });
                    }}
                  />
                </div>
              </div>
              <button 
                onClick={onClose}
                className="p-2 hover:bg-white/10 rounded-full transition-colors"
                title="Close (ESC)"
              >
                <ImCross size={16} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="px-6 py-2 pb-4 max-h-[calc(100vh-150px)] overflow-y-auto ">
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <LoadingSpinner size={60} color="#000000" />
              </div>
            ) : ComponentToRender && fullEntryData ? (
              <ComponentToRender
                isModal={true}
                entry={fullEntryData}
                comeBack={null}
                updatedDate={modalDate.startDate}
                onModalClose={onClose}
                onModalSuccess={handleSaveSuccess}
              />
            ) : (
              <div className="text-center py-12 text-gray-500">
                Failed to load transaction
              </div>
            )}
          </div>
        </div>
      </div>
  {showDeleteModal && (
        <DeleteDataModal
          selectedLedger={selectedDeleteEntry}
          handleDeleteModalClose={() => {
            setShowDeleteModal(false);
            setSelectedDeleteEntry(null);
          }}
          handleDeleteLedgerApi={handleDeleteApi}
          showinputFields={true}
        />
      )}

    </div>
  );
};

export default TransactionEditModal;